export const INVALID_FILENAME_CHARACTERS_REGEX = /[<>:"/\\|?*]/g;
export const WINDOWS_RESERVED_FILENAME_REGEX =
  /^(con|prn|aux|nul|com[1-9]|lpt[1-9])(?:\..*)?$/i;
